export const getRiderCoverageValues = ({
  isDetection,
  isLiable,
  isCharger,
  isEsports,
  isWsports,
  isTravelsc,
  isPccover,
  isMobilecover,
  isCancellationOfSelfParticipationOnRentedCar,
  isOwnerHospital2,
  travelers = [],
}) => ({
  isDetection: Boolean(isDetection),
  isLiable: Boolean(isLiable),
  isCharger: Boolean(isCharger),
  isEsports: Boolean(isEsports),
  isWsports: Boolean(isWsports),
  isTravelsc: Boolean(isTravelsc),
  isPccover: Boolean(isPccover),
  isMobilecover: Boolean(isMobilecover),
  isCancellationOfSelfParticipationOnRentedCar: Boolean(isCancellationOfSelfParticipationOnRentedCar),
  isOwnerHospital2,
  travelers: travelers.map((traveler) => {
    const needDateExtremeSport = Boolean(isEsports && traveler.needDateExtremeSport);
    const needDateWinterSport = Boolean(isWsports && traveler.needDateWinterSport);
    const needPcCoverage = Boolean(isPccover && traveler.needPcCoverage);
    const needMobileCoverage = Boolean(isMobilecover && traveler.needMobileCoverage);

    return {
      needDateExtremeSport,
      dateExtremeSportRange: needDateExtremeSport ? traveler.dateExtremeSportRange : undefined,
      needDateWinterSport,
      dateWinterSportRange: needDateWinterSport ? traveler.dateWinterSportRange : undefined,
      needPcCoverage,
      pc: needPcCoverage ? traveler.pc : undefined,
      needMobileCoverage,
      mobile: needMobileCoverage ? traveler.mobile : undefined,
      cancellationOfSelfParticipationOnRentedCar: Boolean(
        isCancellationOfSelfParticipationOnRentedCar && traveler.cancellationOfSelfParticipationOnRentedCar,
      ),
    };
  }),
});
